var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6050_34306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11.0002C5.53043 11.0002 7 11.0001 7 11.0001C7 11.0001 7 12.4698 7 13.0002V15.0002H17V13.0002C17 12.4698 17 11.0001 17 11.0001C17 11.0001 18.4696 11.0002 19 11.0002C19.5304 11.0002 21 11 21 11C21 11 21 12.4698 21 13.0002V17.0002C21 17.5306 21 19 21 19C21 19 19.5304 19.0002 19 19.0002H5C4.46957 19.0002 3.00067 19.0002 3.00067 19.0002C3.00067 19.0002 3 17.5306 3 17.0002V13.0002C3 12.4698 3.00067 11.0002 3.00067 11.0002C3.00067 11.0002 4.46957 11.0002 5 11.0002Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11V6C5 5.20435 5 3 5 3C5 3 7.20435 3 8 3H16C16.7956 3 19 3 19 3C19 3 19 5.20435 19 6V11",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19V22",
    stroke: "#212121",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19V22",
    stroke: "#212121",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6050_34306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.6e8cdac3f21008f48725a13655de4701.svg";
export { ForwardRef as ReactComponent };